import { useTranslation } from "react-i18next";
import styles from "../styles/profile.module.scss";
import Button from "../../../components/shared/Button/Button";
import { formatDateToDMY } from "../../../utils/helpers";

const discount = "";

interface IProps {
  currentId: number;
  nextPay: string;
  currentSubItem: any;
  clickHandler?: any;
}
const MySubscriptionsCard = ({ currentId, nextPay, currentSubItem, clickHandler }: IProps) => {
  const { t, i18n } = useTranslation();
  const dirData = i18n.language === "ar" ? "rtl" : "ltr";
  const currentCost = currentId === 2 ? +(+currentSubItem?.price / 12).toFixed(2) : currentSubItem?.price;

  return (
    <div className={styles.mySubCardWrapper}>
      <div className={styles.cardBlock}>
        <div className={styles.cardHolder}>
          <div className={styles.mySubCardAmount}>
            {discount && (
              <div className={styles.mySubDiscount}>
                {t("shortDiscount")} {discount}
              </div>
            )}
            <div dir={dirData} className={styles.mySubCardAmountTitle}>
              {currentId === 0 && t("free")}
              {currentId === 1 && t("oneMonth")}
              {currentId === 2 && t("oneYear")}
            </div>
          </div>
          <div className={styles.mySubCardExpiration}>
            {currentId === 0 ? (
              t("free")
            ) : (
              <>
                <p>{t("nextPayment")}</p>
                <p>{formatDateToDMY(nextPay)}</p>
              </>
            )}
          </div>
        </div>
        <div className={styles.cardRightContent}>
          <div className={styles.cardRightBox}>
            {currentId === 0 ? (
              <Button title={t("changeAPlan")} submit={clickHandler} className={styles.changePlanBtn} />
            ) : (
              <div className={styles.priceWrapperDefault}>
                <span>{t("active")}</span>
                <div className={styles.buttonsWrapper}>
                  <Button title={t("continueWithDiscount")} submit={() => {}} className={styles.mySubCardButton} />
                </div>
              </div>
            )}
          </div>
          <div className={styles.mySubCardInfo}>
            <p>
              {currentId === 0 ? "0.00" : currentCost} {t("perMth")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySubscriptionsCard;
